import { render, staticRenderFns } from "./xidiItem2.vue?vue&type=template&id=9c6fc5a8&scoped=true&"
import script from "./xidiItem2.vue?vue&type=script&lang=js&"
export * from "./xidiItem2.vue?vue&type=script&lang=js&"
import style0 from "./xidiItem2.vue?vue&type=style&index=0&id=9c6fc5a8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c6fc5a8",
  null
  
)

export default component.exports